import React from 'react';
import { Resume } from './pages/Resume';
export function App() {
  return <Resume data-id="element-0" />;
}